import { DocChronologySummary } from '../../../../../../../../../../../backend/src/matter/subset/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import formatDate from '@/helpers/formatDate';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

interface AddToDocChronologyDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoadingDocChronologies: boolean;
  docChronologies: DocChronologySummary[];
  handleSelectDocChronology: (docChronologyId: string) => void;
  isAddingDocs: boolean;
  description: string;
}

export const AddToDocChronologyDialog = ({
  isOpen,
  onOpenChange,
  docChronologies,
  handleSelectDocChronology,
  isAddingDocs,
  description,
}: AddToDocChronologyDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--folder-git-2" />
            Add to Existing Document Chronology
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center justify-start">
          <div className="w-full">
            <div
              className={`${isAddingDocs ? 'opacity-50' : 'opacity-100'} flex w-full flex-col justify-between gap-2`}
            >
              {docChronologies.map((docChronology) => {
                return (
                  <div
                    key={docChronology.id}
                    className="flex items-center justify-between rounded-md border bg-gradient-to-r from-gray-50 px-4 py-2.5 pr-2.5 text-sm"
                  >
                    <div className="flex flex-col">
                      <p className="line-clamp-1 font-medium text-ellipsis">{docChronology.title}</p>
                      <p className="text-xs text-gray-500">Created {formatDate(docChronology.createdAt)}</p>
                    </div>
                    <Button
                      className="bg-gray-100"
                      onClick={() => handleSelectDocChronology(docChronology.id)}
                      disabled={isAddingDocs}
                    >
                      <Icon className="lucide--plus" /> Add
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
